import React, { FC, PropsWithChildren } from "react";
import PortalContext from "../../context/portalContext";

/**
 * We use the context API to inform library components that they are being used outside
 * of the portal
 */
const IsNotPortalProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PortalContext.Provider value={{ isPortal: false }}>
      {children}
    </PortalContext.Provider>
  );
};

export default IsNotPortalProvider;
